import { bindMediaCarousels, disposeMediaCarousels } from './media-carousel.js';
// One observer per video. Disposal prevents detached editor sections retaining timers/listeners.
const videos = new Map();
export function bindEditableMedia(scope = document) {
  bindMediaCarousels(scope);
  scope.querySelectorAll('video[data-z-autoplay]').forEach(video => {
    if (videos.has(video)) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, pausedByUser = false, internalPause = false;
    const stop = () => { if (!video.paused) { internalPause = true; video.pause(); } };
    const sync = () => {
      if (visible && !motion.matches && !document.hidden && !pausedByUser && !window.Shopify?.designMode) {
        video.muted = true;
        video.play().catch(() => {});
      } else stop();
    };
    const paused = () => { if (internalPause) internalPause = false; else pausedByUser = true; };
    const played = () => { pausedByUser = false; };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold: .25});
    video.addEventListener('pause', paused);
    video.addEventListener('play', played);
    motion.addEventListener('change', sync);
    document.addEventListener('visibilitychange', sync);
    observer.observe(video);
    videos.set(video, () => {
      observer.disconnect();
      motion.removeEventListener('change', sync);
      document.removeEventListener('visibilitychange', sync);
      video.removeEventListener('pause', paused);
      video.removeEventListener('play', played);
      video.pause();
    });
  });
}
export function disposeEditableMedia(scope) {
  disposeMediaCarousels(scope);
  for (const [video, dispose] of videos) if (scope.contains(video)) { dispose(); videos.delete(video); }
  scope.querySelectorAll('*').forEach(element => element.zaylaDispose?.());
}
function selectBlock(event) {
  const target = event.target;
  const announcement = target.closest?.('.announcement');
  if (announcement && event.detail?.blockId) announcement.zaylaSelectAnnouncement?.(event.detail.blockId);
  target.closest('details')?.setAttribute('open', '');
  target.scrollIntoView?.({block:'nearest', inline:'nearest', behavior:'instant'});
  target.querySelectorAll?.('video').forEach(video => video.pause());
}
document.addEventListener('shopify:section:load', event => bindEditableMedia(event.target));
document.addEventListener('shopify:section:unload', event => disposeEditableMedia(event.target));
document.addEventListener('shopify:block:select', selectBlock);
document.addEventListener('shopify:section:select', selectBlock);
bindEditableMedia();
